import { Button, Icon, Popover } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

const CopyToClipboard = ({ valueToCopy, popOverDirection, popOverWidth }) => {
  return (
    <Popover
      text="Copy to clipboard"
      direction={popOverDirection}
      width={popOverWidth}
    >
      <Button
        mt="6"
        ml="s"
        height="20px"
        small
        onClick={() => {
          navigator.clipboard.writeText(valueToCopy);
        }}
      >
        <Icon icon={["fas", "copy"]} />
      </Button>
    </Popover>
  );
};

CopyToClipboard.propTypes = {
  valueToCopy: PropTypes.string.isRequired,
  popOverDirection: PropTypes.string,
  popOverWidth: PropTypes.string,
};

export default CopyToClipboard;
